import {
  createApiClient,
  addRequestInterceptor,
  addResponseInterceptor,
  ApiClientConfig,
  removeRequestInterceptor,
  removeResponseInterceptor,
} from '../rest-client';
import { type AxiosResponse, type AxiosRequestConfig, InternalAxiosRequestConfig, AxiosError } from 'axios';
import { config } from '@/config';
import { Logger } from '@/Logger';

const API_BASE_URL = config.baseUrl || 'http://localhost:3000';

const BASE_SM_CONFIG: Omit<ApiClientConfig, 'baseURL'> = {
  headers: {
    'Content-type': 'application/json',
    Accept: 'application/json;odata=minimalmetadata',
  },
  cache: {
    ttl: 15 * 60 * 1000,
  },
};

export const SmRestClient = createApiClient({
  baseURL: `${API_BASE_URL}/api/v1`,
  ...BASE_SM_CONFIG,
});

// Supplier Management Rest Clients Interceptors ( Request and Response), Should be initialized in the app entry point

export const addSmRequestInterceptors = (getSmToken: () => Promise<string | undefined>) => {
  const handleReject = (error: any): any => {
    return Promise.reject(error);
  };
  const handleResolve = async <T>(config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
    const accessToken = await getSmToken();

    config.headers['Authorization'] = `Bearer ${accessToken}`;

    const modifiedConfig: InternalAxiosRequestConfig = {
      ...config,
    };

    return modifiedConfig;
  };

  return addRequestInterceptor<{
    config: AxiosRequestConfig;
  }>(SmRestClient, handleResolve, handleReject);
};

export const addSmResponseInterceptors = (reditectToUnauthorized: () => void) => {
  const handleReject = (error: unknown): unknown => {
    if (error instanceof AxiosError)
      if (error.response!.status === 403 || error.response!.status === 401) {
        reditectToUnauthorized();
      } else if(error.response!.status === 500) {
        Logger.error('Internal server error');
      } else if(error.response!.status >= 600) {
        Logger.error('WAF error');
      }
    return Promise.reject(error);
  };

  const handleResolve = <T>(response: AxiosResponse<T>): AxiosResponse<T> | Promise<AxiosResponse<T>> => {
    return response;
  };

  return addResponseInterceptor(SmRestClient, handleResolve, handleReject);
};

export const removeSmResponseInterceptors = (interceptorId: number) => {
  removeResponseInterceptor(SmRestClient, interceptorId);
};
export const removeSmRequestInterceptors = (interceptorId: number) => {
  removeRequestInterceptor(SmRestClient, interceptorId);
};
